'use client';

import '@/lib/logging.client';

export function LoggingInit() {
  return null;
}
